import React, { useState, useEffect } from 'react';
import NearbyVendorsPage from './NearbyVendorsPage';
import NearbyPickupPage from './NearbyPickupPage';
import SearchBar from './SearchBar';
import DPNavBar from './DPNavBar';
import FilterComponent from './FilterComponent';
import './DeliveryPickupWrapper.css';

const DeliveryPickupWrapper = () => {
  const [selectedOption, setSelectedOption] = useState('Delivery');
  const [searchQuery, setSearchQuery] = useState('');
  const [animate, setAnimate] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const [activeFilters, setActiveFilters] = useState({
    eta: null,
    strain: [],
    category: [],
    priceRange: [0, 200]
  });

  useEffect(() => {
    setAnimate(true);

    // Add scroll listener for toolbar shadow
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 0);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleFilterChange = (filters) => {
    setActiveFilters(filters);
  };

  return (
    <div className={`delivery-pickup-wrapper ${animate ? 'slide-in' : ''}`}>
      {/* Navbar */}
      <DPNavBar 
        selectedOption={selectedOption} 
        setSelectedOption={setSelectedOption}
      />

      {/* Toolbar Section */}
      <div className={`toolbar-container ${isScrolled ? 'scrolled' : ''}`}>
        <div className="toolbar-inner">
          <SearchBar searchQuery={searchQuery} setSearchQuery={setSearchQuery} />
          <FilterComponent onFilterChange={handleFilterChange} />
        </div>
      </div>

      {/* Content Section */}
      <div className="content-section">
        {selectedOption === 'Delivery' ? (
          <NearbyVendorsPage 
            searchQuery={searchQuery} 
            activeFilters={activeFilters}
          />
        ) : (
          <NearbyPickupPage 
            searchQuery={searchQuery}
            activeFilters={activeFilters}
          />
        )}
      </div>
    </div>
  );
};

export default DeliveryPickupWrapper;